import React from 'react';
import { Bookmark, BookmarkActionHandlers } from './shared/types';
import { CardLayout } from './layouts/CardLayout';
import { GroupedCardLayout } from './layouts/GroupedCardLayout';
import { ListLayout } from './layouts/ListLayout';
import { GroupedListLayout } from './layouts/GroupedListLayout';

interface BookmarkLayoutProps {
  bookmarks: Bookmark[];
  handlers: BookmarkActionHandlers;
  viewMode: 'card' | 'list';
  useGroupedLayout: boolean;
}

export const BookmarkLayout: React.FC<BookmarkLayoutProps> = ({
  bookmarks,
  handlers,
  viewMode,
  useGroupedLayout
}) => {
  if (useGroupedLayout) {
    return viewMode === 'card' ? (
      <GroupedCardLayout bookmarks={bookmarks} handlers={handlers} />
    ) : (
      <GroupedListLayout bookmarks={bookmarks} handlers={handlers} />
    );
  }

  return viewMode === 'card' ? (
    <CardLayout bookmarks={bookmarks} handlers={handlers} />
  ) : (
    <ListLayout bookmarks={bookmarks} handlers={handlers} />
  );
};